// extracted by mini-css-extract-plugin
export default {"maintenanceText":"paypal-maintenance-notice_maintenanceText__jZWwt"};